const isWooCommerceShop = (user) => !!user?.publisher?.woocommerce_oauth;
export default isWooCommerceShop;
